import React, { Component, useState } from 'react';
import swal from 'sweetalert';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as ReleaseNotesMaintenanceAction from '../actions/ReleaseNotesMaintenanceAction';
import ReleaseNotesMaintenanceStore from '../stores/ReleaseNoteMaintenanceStore';
import { withTranslation, Trans } from 'react-i18next';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import * as ReleaseNotesMaintenanceComponent from '../components/ReleaseNotesMaintenanceComponent';
import { width } from '@material-ui/system';

const numberRegEX = /^[0-9\b.]+$/;
let deleteVal = {};
let deleteIndex = {};
let paramSource;

class AddVersionComponent extends Component {
    constructor(props) {
        super(props);
        paramSource= this.props.location.state.source;
        this.state = {
            source: this.props.location.state.source,
            webVersion: this.props.location.state.webVersion,
            mobileVersion: this.props.location.state.mobileVersion,
            submitType: this.props.location.state.submitType,
            enhancementArr: this.props.location.state.sendEnhancementArr,
            bugArr: this.props.location.state.sendBugArr,
            duplicateEnhancementArr: JSON.parse(JSON.stringify(this.props.location.state.sendEnhancementArr)),
            duplicateBugArr: this.props.location.state.sendBugArr,
            taskType: "E",
            titleValue: "",
            editTaskIndex: 0,
            actionType: "I",
            changeType: "",
            webVersions: this.props.location.state.webVersions,
            mobVersions: this.props.location.state.mobVersions,
            hideTask: false
            
        }
        
       // console.log("source", this.state.source);
        //console.log("source", this.state.webVersion);
        //console.log("source", this.state.mobileVersion);
       // console.log("source", this.state.enhancementArr);
       // console.log("source", this.state.bugArr);
        //console.log("source", this.state.duplicateEnhancementArr);
        //console.log("source", this.state.duplicateBugArr);






    }
    componentDidMount() {
        ReleaseNotesMaintenanceStore.on('saveSuccess', this.BuildSaveMessage);

    }
    componentWillUnmount() {
        ReleaseNotesMaintenanceStore.removeListener('saveSuccess', this.BuildSaveMessage);
    }
    

    setSelectedSource = (e) => {
        if (this.state.source === "WEB") {
            this.setState({ source: e.currentTarget.attributes.value.value, mobileVersion: "" })
        }
        else if (this.state.source === "MOB") {
            this.setState({ source: e.currentTarget.attributes.value.value, webVersion: "" })
        }
        else if (this.state.source === "BOTH") {
            this.setState({ source: e.currentTarget.attributes.value.value, webVersion: "", mobileVersion: "" })
        }
    }

    setTaskType = (e) => {
        this.setState({ taskType: e.currentTarget.attributes.value.value })
    }

    onChangeWebVersion = (e) => {
        if (e.target.value === '' || numberRegEX.test(e.target.value)) {
           // console.error("WebVersion onChange value", e.target.value)
            this.setState({ webVersion: e.target.value })
        }
    }

    onChangeMobVersion = (e) => {
        if (e.target.value === '' || numberRegEX.test(e.target.value)) {
          //  console.error("MobVersion onChange value", e.target.value)
            this.setState({ mobileVersion: e.target.value })
        }
    }

    validateWebVersion = () => {
        if (this.state.webVersions.includes(this.state.webVersion)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Desktop version number already exist"
            });
            return false
        }
        return true
    }

    validateMobVersion = () => {
        if (this.state.mobVersions.includes(this.state.mobileVersion)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Mobile version number already exist"
            });
            return false
        }
        return true
    }

    setTitle = (e) => {
        this.setState({ titleValue: e.target.value })
    }

    cancelTask = () => {
        this.setState({ titleValue: "", taskType: "E", actionType: "I", hideTask: false })
    }

    editTask = (val, index) => {
        
        this.setState({ taskType: val.TASK_TYPE, titleValue: val.TASK_TITLE, editTaskIndex: index, actionType: "U", changeType: val.TASK_TYPE, hideTask: true })
        window.scrollTo(0, 0);
    }

    addTask = () => {
        let newItem = {};
        let newArr = [];
        
        if (this.state.titleValue.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please provide a title"
            });
        }
        else {
            if (this.state.actionType === "I") {
                newItem = {
                    TASK_TITLE: this.state.titleValue,
                    TASK_TYPE: this.state.taskType,
                };
                if (this.state.taskType === "E") {
                    newArr = this.state.duplicateEnhancementArr.concat(newItem);
                    this.setState({ duplicateEnhancementArr: newArr, taskType: "E", titleValue: "" })
                }
                else if (this.state.taskType === "B") {
                    newArr = this.state.duplicateBugArr.concat(newItem);
                    this.setState({ duplicateBugArr: newArr, taskType: "B", titleValue: "" })
                }
            }
            else if (this.state.actionType === "U") {
                if (this.state.taskType === this.state.changeType) {
                    if (this.state.taskType === "E") {
                        let localArr = JSON.parse(JSON.stringify(this.state.duplicateEnhancementArr));
                        localArr[this.state.editTaskIndex].TASK_TITLE = this.state.titleValue;
                        localArr[this.state.editTaskIndex].TASK_TYPE = this.state.taskType;
                       // console.error("localArr", localArr);
                       // console.error("duplicateEnhancementArr", this.state.duplicateEnhancementArr);
                       // console.error("enhancementArr", this.state.enhancementArr);
                        this.setState({ taskType: "E", titleValue: "", actionType: "I", duplicateEnhancementArr: localArr, hideTask: false })
                    }
                    else if (this.state.taskType === "B") {
                        let localArr = JSON.parse(JSON.stringify(this.state.duplicateBugArr));
                        localArr[this.state.editTaskIndex].TASK_TITLE = this.state.titleValue;
                        localArr[this.state.editTaskIndex].TASK_TYPE = this.state.taskType;
                        //console.error("localArr", localArr);
                        //console.error("duplicateBugArr", this.state.duplicateBugArr);
                        //console.error("bugArr", this.state.bugArr);
                        this.setState({ taskType: "E", titleValue: "", actionType: "I", duplicateBugArr: localArr, hideTask: false })
                    }
                }
                else if (this.state.taskType !== this.state.changeType) {
                    newItem = {
                        TASK_TITLE: this.state.titleValue,
                        TASK_TYPE: this.state.taskType,
                    };
                    if (this.state.taskType === "E") {
                        newArr = this.state.duplicateEnhancementArr.concat(newItem);
                        let localArr = JSON.parse(JSON.stringify(this.state.duplicateBugArr));
                        localArr.splice(this.state.editTaskIndex, 1);
                        this.setState({ duplicateEnhancementArr: newArr, taskType: "E", titleValue: "", duplicateBugArr: localArr, actionType: "I", hideTask: false })
                    }
                    else if (this.state.taskType === "B") {
                        newArr = this.state.duplicateBugArr.concat(newItem);
                        let localArr = JSON.parse(JSON.stringify(this.state.duplicateEnhancementArr));
                        localArr.splice(this.state.editTaskIndex, 1);
                        this.setState({ duplicateBugArr: newArr, taskType: "B", titleValue: "", duplicateEnhancementArr: localArr, actionType: "I", hideTask: false })
                    }
                }
            }
        }
        
    }

    deleteTask = (val, index) => {
        if (val.TASK_TYPE === "E") {
            let localArr = JSON.parse(JSON.stringify(this.state.duplicateEnhancementArr));
            localArr.splice(index, 1);
            this.setState({ editTaskIndex: 0, duplicateEnhancementArr: localArr })
        }
        else if (val.TASK_TYPE === "B") {
            let localArr = JSON.parse(JSON.stringify(this.state.duplicateBugArr));
            localArr.splice(index, 1);
            this.setState({ editTaskIndex: 0, duplicateBugArr: localArr })
        }
    }

    showDeletePopUp = (val,index) => {
        ;
        if (this.state.hideTask) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please finish editing before deleting"
            });
        }
        else {
            deleteVal = val;
            deleteIndex = index;
            $('#deletePopUp').modal('show');
        }
    }


    deleteAction = (value) => {
        ;
        if (value == "No") {
            $('#deletePopUp').modal('hide');
        }
        else {
            $('#deletePopUp').modal('hide');
            this.deleteTask(deleteVal, deleteIndex)
        }
    }


    showCancelPopUp = () => {
        
        $('#cancelPopUp').modal('show');
    }

    cancelOperation = (value) => {
        
        if (this.state.submitType === "Insert") {
            if (value == "No") {
                $('#cancelPopUp').modal('hide');
            }
            else {
                $('#cancelPopUp').modal('hide');
                this.props.history.push({
                    pathname: "/releasenotesmaintenance",
                    state: { source: paramSource }
                });
            }
        }
        else if (this.state.submitType === "Update") {
            if (value == "No") {
                $('#cancelPopUp').modal('hide');
            }
            else {
                $('#cancelPopUp').modal('hide');
                this.props.history.push({
                    pathname: "/releasenotesmaintenance",
                    state: { source: paramSource }
                });
                this.setState({ duplicateEnhancementArr: this.state.enhancementArr, duplicateBugArr: this.state.bugArr, titleValue: "", hideTask: false })
            }
        }
    }

    submitData = () => {
        
        let canWebSubmit = true;
        let canMobSubmit = true;
        if (this.state.submitType == "Insert") {
            if (this.state.source == "BOTH") {
                if (this.state.webVersion == "" || this.state.mobileVersion == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter both version numbers"
                    });
                    return
                }
                else if (this.state.duplicateEnhancementArr.length == 0 && this.state.duplicateBugArr.length == 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Enhancements and Bugs cannot be empty"
                    });
                    return
                }

            }
                else if (this.state.webVersion == "" && this.state.mobileVersion == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter the version number"
                    });
                    return
                }
                else if (this.state.duplicateEnhancementArr.length == 0 && this.state.duplicateBugArr.length == 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Enhancements and Bugs cannot be empty"
                    });
                    return
                }
            canWebSubmit = this.validateWebVersion();
            canMobSubmit = this.validateMobVersion();
        }
        if (canWebSubmit === true && canMobSubmit === true) {
            let updatedVersionArr = [...this.state.duplicateEnhancementArr, ...this.state.duplicateBugArr]
            let insertData = {
                updatedVersionArr: updatedVersionArr,
                mobileVersion: this.state.mobileVersion,
                webVersion: this.state.webVersion,
                source: this.state.source,
                submitType: this.state.submitType
            }
            ReleaseNotesMaintenanceAction.submitDataAction(insertData)
        }
            
    }


    BuildSaveMessage = () => {
        if ((ReleaseNotesMaintenanceStore.saveResponse) == "True") {
            $('#successPopUp').modal('show');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "There is an error in saving the version"
            });
        }

    }

    navigate = () => {
        $('#successPopUp').modal('hide');
        this.props.history.push({
            pathname: "/releasenotesmaintenance",
            state: { source: paramSource }
        });
    }



    bindEnhancement = () => {
        return this.state.duplicateEnhancementArr.map((val, index) => (
            <Draggable
                key={index} 
                draggableId={index.toString()} 
                index={index}
                isDragDisabled={this.state.hideTask}
            >
                {(provided) => (
                    <tr hidden={index === this.state.editTaskIndex && this.state.hideTask === true && this.state.changeType == "E" ? true : false}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <td className={index == 0 ? ("border-top-0") : null}>
                            <span >
                                <img src="images/drag.svg" alt="drag-drop" />
                            </span>
                        </td>
                        <td className={index == 0 ? ("border-top-0 dragAndDropWidth") : ("dragAndDropWidth")} colSpan={2}>
                            {val.TASK_TITLE}
                        </td>
                        <td className={index == 0 ? ("font-medium border-top-0 action-icon-res text-res-center") : ("font-medium action-icon-res text-res-center")} colSpan={1}>
                            <a className="mr-3 cursor-pointer">
                                <img
                                    src="images/edit-icon.svg"
                                    alt="edit"
                                    title="Edit"
                                    onClick={() => { this.editTask(val, index) }}
                                />
                            </a>
                            <a className="cursor-pointer">
                                <img
                                    src="images/delete-releasenotes-icon.svg"
                                    alt="delete"
                                    title="Delete"
                                    onClick={() => { this.showDeletePopUp(val, index) }}
                                />
                            </a>
                        </td>
                    </tr>
                )}
            </Draggable>
        ));
    }


    bindBug = () => {
        return this.state.duplicateBugArr.map((val, index) => (
            <Draggable
                key={index} 
                draggableId={index.toString()} 
                index={index}
                isDragDisabled={this.state.hideTask}
            >
                {(provided) => (
                    <tr hidden={index === this.state.editTaskIndex && this.state.hideTask === true && this.state.changeType == "B" ? true : false}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <td className={index == 0 ? ("border-top-0") : null}>
                            <span>
                                <img src="images/drag.svg" alt="drag-drop" />
                            </span>
                        </td>
                        <td className={index == 0 ? ("border-top-0 dragAndDropWidth") : ("dragAndDropWidth")} colSpan={2}>
                            {val.TASK_TITLE}
                            </td>
                        <td className={index == 0 ? ("font-medium border-top-0 ") : ("font-medium ")} colSpan={1}>
                            <a className="mr-3 cursor-pointer">
                                <img
                                    src="images/edit-icon.svg"
                                    alt="edit"
                                    title="Edit"
                                    onClick={() => { this.editTask(val, index) }}
                                />
                            </a>
                            <a className="cursor-pointer">
                                <img
                                    src="images/delete-releasenotes-icon.svg"
                                    alt="delete"
                                    title="Delete"
                                    onClick={() => { this.showDeletePopUp(val, index) }}
                                />
                            </a>
                        </td>
                    </tr>
                )}
            </Draggable>
        ));
    }

    onDragEndEnhancement = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedItems = Array.from(this.state.duplicateEnhancementArr);
        const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, reorderedItem);

        this.setState({ duplicateEnhancementArr: reorderedItems });
    };

    onDragEndBug = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedItems = Array.from(this.state.duplicateBugArr);
        const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, reorderedItem);

        this.setState({ duplicateBugArr: reorderedItems });
    };



    render(){
        return (<React.Fragment>
            <div className="container-fluid container-margin content-section">
                <div className="">
                    <h5 className="page-title"><span class="pr-2"><a className="cursor-pointer" title="Back" onClick={() => this.navigate()}><img src="images/arrow-1.svg" alt="logo" /></a></span>{(this.state.submitType !== "Insert") ? (this.state.webVersion !== "" ? this.state.webVersion : this.state.mobileVersion) : ("Add Version")}</h5>
                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                </div>
                <div>
                    <title>Add New Version</title>
                    <meta charSet="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <link rel="stylesheet" type="text/css" href="css/sdiframework.css" />
                    <link rel="stylesheet" type="text/css" href="css/sdistyles.css" />
                    <div className="container-fluid">
                        <div className="row">
                            {/*Forms starts here*/}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-3 mt-3 mb-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="font-14 font-medium text-black mandatory-after mb-0">Choose platform</label>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="sourceChoice" id="Desktop" value="WEB" checked={this.state.source === "WEB"} onChange={(e) => { this.setSelectedSource(e) }} disabled={this.state.submitType === "Update"} />
                                            <label className="form-check-label font-12 font-regular mr-3" htmlFor="Desktop" disabled={this.state.submitType === "Update"} >Desktop</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="sourceChoice" id="Mobile" value="MOB" checked={this.state.source === "MOB"} onChange={(e) => { this.setSelectedSource(e) }} disabled={this.state.submitType === "Update"} />
                                            <label className="form-check-label font-12 font-regular mr-3" htmlFor="Mobile" disabled={this.state.submitType === "Update"} >Mobile</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="sourceChoice" id="Both" value="BOTH" checked={this.state.source === "BOTH"} onChange={(e) => { this.setSelectedSource(e) }} disabled={this.state.submitType === "Update"} />
                                            <label className="form-check-label font-12 font-regular mr-3" htmlFor="Both" disabled={this.state.submitType === "Update"} >Both</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.source === "WEB" || this.state.source === "BOTH" ?
                                <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-4">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label id="version-number" className="font-14 font-medium text-black mandatory-after mb-0 mt-2">Desktop Version Number</label>
                                        </div>
                                        <div className="col-md-8">
                                            <input id="webTxtBx" type="text" className="form-control custom-form-style" placeholder="Enter Version" maxLength="10" value={this.state.webVersion} onChange={(e) => { this.onChangeWebVersion(e) }} onBlur={(e) => { this.validateWebVersion(e) }} disabled={this.state.submitType=="Update"} />
                                        </div>
                                    </div>
                                </div> : null}
                            {this.state.source === "MOB" || this.state.source === "BOTH" ?
                                <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-4">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="font-14 font-medium text-black mandatory-after mb-0 mt-2">Mobile Version Number</label>
                                        </div>
                                        <div className="col-md-8">
                                            <input id="mobTxtBx" type="text" className="form-control custom-form-style" placeholder="Enter Version" maxLength="10" value={this.state.mobileVersion} onChange={(e) => { this.onChangeMobVersion(e) }} onBlur={(e) => { this.validateMobVersion(e) }} disabled={this.state.submitType == "Update"}/>
                                        </div>
                                    </div>
                                </div> : null}
                           

                            {/*Inline grid starts here*/}
                            <div className="col-md-12 mt-4">
                                <h6 className="text-black font-16 font-bold">Version Info</h6>
                                <div className="table-responsive mb-3">
                                    <table className="table split-delv-table tbl-wrap-res">
                                        <thead className="top">
                                            <tr>
                                                <th className>Type</th>
                                                <th className>Title</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className = "typeRDO">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="taskTypeChoice" id="Enhancements" value="E" checked={this.state.taskType === "E"} onChange={(e) => { this.setTaskType(e) }} />
                                                        <label className="form-check-label font-12 font-regular mr-3" htmlFor="Enhancements">Enhancements</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="taskTypeChoice" id="Bugs" value="B" checked={this.state.taskType === "B"} onChange={(e) => { this.setTaskType(e) }} />
                                                        <label className="form-check-label font-12 font-regular" htmlFor="Bugs">Bugs</label>
                                                    </div>
                                                </td>
                                                <td className="textStyle"><input type="text" className="form-control tbl-res-search custom-form-style" placeholder="Enter Version Title" maxLength="254" value={this.state.titleValue} onChange={(e) => { this.setTitle(e) }} /></td>
                                                <td className="text-center"><a className="cursor-pointer" ><img className src="images/add-task-icon.svg" alt="add" title={this.state.actionType === "I" ? "Add" : "Update"} onClick={(e) => { this.addTask(e) }} /></a><span className="cursor-pointer" onClick={() => { this.cancelTask() }}><img className="cancel_Task_Style" src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" /></span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    

                                    <DragDropContext onDragEnd={this.onDragEndEnhancement} >
                                        <Droppable droppableId="enhancement" type="ENHANCEMENT" isDropDisabled={this.state.hideTask} >
                                            {(provided) => (
                                                <table className="table split-delv-table" ref={provided.innerRef}>
                                                    <thead className="top">
                                                        <tr>
                                                            <td className="font-medium" colSpan={4}>Enhancement</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Render Enhancement rows */}
                                                        {this.bindEnhancement()}
                                                    </tbody>
                                                    {provided.placeholder}
                                                </table>
                                            )}
                                        </Droppable>
                                    </DragDropContext>

                                    <DragDropContext onDragEnd={this.onDragEndBug}>
                                        <Droppable droppableId="bug" type="BUG" isDropDisabled={this.state.hideTask} >
                                            {(provided) => (
                                                <table className="table split-delv-table" ref={provided.innerRef}>
                                                    <thead className="top">
                                                        <tr>
                                                            <td className="font-medium" colSpan={4}>Bugs</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Render Bug rows */}
                                                        {this.bindBug()}
                                                    </tbody>
                                                    {provided.placeholder}
                                                </table>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                           

                                </div>
                            </div>
                            {/*Inline grid ends here*/}

                            {/*buttons starts here*/}
                            <div className="col-md-12 mb-3">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-custom-secondary font-15 font-medium mr-3 mb-2 px-4 py-2 " onClick={() => { this.showCancelPopUp() }}>Cancel</button>
                                    <button className="btn btn-custom-primary font-15 font-medium mb-2 px-4 py-2" onClick={() => { this.submitData() }}>{this.state.submitType === "Update" ? "Update" : "Submit"}</button>
                                </div>
                            </div>
                            {/*buttons ends here*/}
                        </div>
                    </div>
                </div>
                {/*cancelpopup*/}
                {/*Modal Starts here*/}
                <div className="modal fade delete-alternate-approver" role="dialog" id="cancelPopUp">
                    <div className="modal-dialog modal-dialog-centered release-notes-custom-delete-width" role="document">
                        <div className="modal-content py-2">
                            {/*Cancel Starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Cancel Confirmation</h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">Are you sure you want to cancel?</p>
                                    </div>
                                </div>
                            </div>
                            {/*Cancel ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={() => { this.cancelOperation("No") }}>No</button>
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.cancelOperation("Yes") }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}

                {/*deletepopup*/}
                {/*Modal Starts here*/}
                <div className="modal fade delete-alternate-approver" role="dialog" id="deletePopUp">
                    <div className="modal-dialog modal-dialog-centered release-notes-custom-delete-width" role="document">
                        <div className="modal-content py-2">
                            {/*Delete Starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/trash.svg" alt="delete" />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Delete Confirmation</h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">Are you sure you want to delete this Task?</p>
                                    </div>
                                </div>
                            </div>
                            {/*Delete ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={() => { this.deleteAction("No") }}>No</button>
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.deleteAction("Yes") }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}


                {/*Modal Starts here*/}
                <div className="modal fade success" tabIndex={-1} role="dialog" id="successPopUp" data-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-4" src="images/tick.svg" alt="tick" />
                                        <p className="mb-1 font-13 font-regular color-light-black">The data is saved successfully!</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => {this.navigate()} }>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}
              </div>
            </React.Fragment>
            )    
}
} export default withTranslation()(AddVersionComponent);